import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Cas } from '../../../../../core/entities/cas.model';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogsCasComponent } from './dialogs-cas/edit-dialogs-cas/edit-dialogs-cas.component';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { Utils } from 'src/app/core/utils/utils';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';

@Component({
  selector: 'app-cas',
  templateUrl: './cas.component.html',
  styleUrls: ['./cas.component.scss']
})
export class CasComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  ca: Cas = new Cas();

  mensajeError: boolean = false;

  constructor(private internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService) {
    super();
  }

  ngOnInit() {
    this.mensajeError = false;
    this.getAllCas();
    this.internalHomeService.mostrarMenu();
  }

  /**
   * @description
   * Se llama al servicio para traernos todos los datos de la tabla cas
   */
  private getAllCas(): void {
    this.loading = true;
    this.internalHomeService.allCas().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
    });
  }

  /**
   * @description
   * Abre el dialog para crear un ca
   * @param parametro Opcional. Ca vacio.
   */
  public createCa(ca?: Cas) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = false;
    ca = this.ca;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsCasComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { ca, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllCas();
      }, 1000);
    });
  }

  /**
   * @description
   * Abre el dialog para modificar un ca
   * @param parametro Opcional. Ca a editar.
   */
  public editCa(ca?: Cas) {
    Utils.toggleAllButtonsAndHref(null);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsCasComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { ca, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(null);
      if(result)
      setTimeout(() => {
        this.getAllCas();
      }, 1000);
    });
  }

  /**
   * @description
   * Elimina un ca
   * @param ca Ca a eliminar
   */
  public removeCa(ca?: Cas) {
    Utils.toggleAllButtonsAndHref(null);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_cas') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(null);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeCas(ca).subscribe(res => {
          console.log(res);
          this.getAllCas();
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
   * Muestra el mensaje de error correspondiente en caso de error
   * @param error Objeto de error.
   */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
